module.exports = __webpack_public_path__ + "static/media/smart-banner-logo.593c0878.png";